import { cva, VariantProps } from 'class-variance-authority'

export type AppointmentStatusPillStyling = VariantProps<typeof appointmentStatusPillStyling>

export const appointmentStatusPillStyling = cva('flex items-center gap-1.5 bg-white rounded-full border border-gray-100 w-fit', {
  variants: {
    size: {
      sm: 'px-2 py-0.5',
      md: 'px-3 py-1',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
